import { trimEnd, trimStart } from 'lodash-es';

/**
 * Combines a base path and a URI into a single URL string,
 * ensuring there are no double slashes.
 */
const getUrl = (base: string) => (uri: string): string => `${trimEnd(base, '/')}/${trimStart(uri, '/')}`;

/**
 * Service links configuration
 */
export const publicSiteUrl = {
    serviceLink: getUrl('/link/'),
} as const;

export default publicSiteUrl;
